(function () {
    'use strict';

    angular
        .module('ib-check-in-search')
        .service('CheckinSearchService', CheckinSearchService);

    CheckinSearchService.$inject = ['$rootScope', 'CommonsCheckLoginWCSService', 'GetFrequentFlyersService', 'ModalService', '$cookies', '$location', 'localStorageService', 'SearchFlightsPassengersService', 'UtilsService', 'CkiDatalayerUtilsService', 'UpdateFlightsPassengerInfoService', 'GetCKICachedInformationService', 'EndpointsService', 'CkiDatalayerConstants', 'CheckinAppConstants', 'CkiCommonsGetLoginInfoService', 'CommonsUserUtilsService', 'CommonsLoginUtilsService', 'FlightsPassengersService', 'NewMainHeaderFacade', '$timeout'];
    function CheckinSearchService ($rootScope, CommonsCheckLoginWCSService, GetFrequentFlyersService, ModalService, $cookies, $location, localStorageService, SearchFlightsPassengersService, UtilsService, CkiDatalayerUtilsService, UpdateFlightsPassengerInfoService, GetCKICachedInformationService, EndpointsService, CkiDatalayerConstants, CheckinAppConstants, CkiCommonsGetLoginInfoService, CommonsUserUtilsService, CommonsLoginUtilsService, FlightsPassengersService, NewMainHeaderFacade, $timeout) {
        const self = this;
        self.initCheckin = initCheckin;
        self.getDinamicPricingCookieParameter = getDinamicPricingCookieParameter;

        ////////////////

        function initCheckin () {
            let params = null, cookiesInfo = null;
            const gdrInfo = JSON.parse(sessionStorage.getItem('IBERIACOM_GDR_PA_ACCESS'));
            const gdrError = JSON.parse(sessionStorage.getItem('IBERIACOM_GDR_PA_ERROR'));
            ModalService.isNotWaiting();
            if (localStorageService.isSupported) {
                localStorageService.set('buildNumber', UtilsService.generateBuildNumberQueryString());
                params = getInitialParameters();
                localStorageService.set('urlParams', params);
                cookiesInfo = CommonsCheckLoginWCSService.generateSSOInfo(true);
                UtilsService.initStorage();
                $rootScope.$broadcast('initializeGreyBar');
                localStorageService.set('channel', params.channel || '');
                if (cookiesInfo.isLogged) {
                    ModalService.isWaiting();
                    getEndpointsVersion(goLoggedAccess);
                } else {
                    goAnonymous();
                }

            } else {
                ModalService.openGenericModal('md', 'ibcose.vista-modal-private-browser-mode', true, { idModal: CkiDatalayerConstants.DATALAYER_MODAL_ID.PRIVATE_BROWSER_ERROR });
            }

            function getInitialParameters () {
                return {
                    pnr: UtilsService.getParameterByName('pnr'),
                    surname: UtilsService.getParameterByName('surname'),
                    market: UtilsService.getParameterByName('market'),
                    language: UtilsService.getParameterByName('language'),
                    channel: UtilsService.getParameterByName('channel'),
                    device: UtilsService.getParameterByName('device'),
                    errorCode: UtilsService.getParameterByName('codeError'),
                    code: UtilsService.getParameterByName('code'),
                    travelAgencies: UtilsService.getTravelAgencies(CheckinAppConstants.UNDOCHECKIN.CKI_AAVV),
                    reInvoicing: UtilsService.getTravelAgencies(CheckinAppConstants.UNDOCHECKIN.UNDOCKI),
                    travelAgent: UtilsService.getParameterByName(CheckinAppConstants.UNDOCHECKIN.TRAVEL_AGENT)
                };
            }

            function searchFlightsPassengers () {
                GetFrequentFlyersService.getFrequentFlyers().then(() => {
                    removeUrlParameters();
                    localStorageService.set('PNR', params.pnr);
                    localStorageService.set('checkinSurname', params.surname);
                    SearchFlightsPassengersService.searchFlighsPassengersByLocatorAndSurname(params.surname, params.pnr, false);
                });
            }

            function searchFlightsDeepLink () {
                GetFrequentFlyersService.getFrequentFlyers().then(() => {
                    removeUrlParameters();
                    SearchFlightsPassengersService.searchFlighsPassengersDeepLink(params.code);
                });
            }

            function serviceError (error) {
                ModalService.isNotWaiting();
                ModalService.setErrorMessage(error.message);
                ModalService.setErrorCode(error.internalErrorCode);
                ModalService.isError(error);
                removeUrlParameters();
            }

            function removeUrlParameters () {
                let cleanParams, ckiQuadrigam = CheckinAppConstants.HASH_PAGES.CHECKIN.replace('#', '#!');
                if ((location.search.indexOf(CheckinAppConstants.UNDOCHECKIN.CKI_AAVV) !== -1 || location.search.indexOf(CheckinAppConstants.UNDOCHECKIN.UNDOCKI) !== -1 || location.search.indexOf(CheckinAppConstants.UNDOCHECKIN.TRAVEL_AGENT) !== -1) && !$location.search().ckiParaAAVV) {
                    cleanParams = delUndoCkiParams();

                    if (UtilsService.getTravelAgencies(CheckinAppConstants.UNDOCHECKIN.CKI_AAVV) && UtilsService.getTravelAgencies(CheckinAppConstants.UNDOCHECKIN.UNDOCKI) && UtilsService.getParameterByName(CheckinAppConstants.UNDOCHECKIN.TRAVEL_AGENT) && !$location.search().ckiParaAAVV) {
                        location = location.pathname + cleanParams + CheckinAppConstants.HASH_PAGES.UNDOCHECKIN + location.search;
                    } else {
                        location = location.pathname + cleanParams + ckiQuadrigam;
                    }
                } else if (location.hash.indexOf(CheckinAppConstants.UNDOCHECKIN.UNDOCKI) === -1 && location.hash.indexOf(CheckinAppConstants.QUADRIGAM.UN_SEARCH.toLowerCase()) !== -1) {
                    location = location.pathname + location.search + ckiQuadrigam;
                } else if (location.search.indexOf(CheckinAppConstants.USER_PARAMS.SURNAME) !== -1 || location.search.indexOf(CheckinAppConstants.USER_PARAMS.PNR) !== -1) {
                    cleanParams = delUndoCkiParams();
                    location = location.pathname + cleanParams + ckiQuadrigam + location.search;
                }


                $location.search({}).replace();

                function delUndoCkiParams () {
                    let regex, docRootParam = '', tempParam, tempRegex;

                    regex = new RegExp(CheckinAppConstants.CHECKIN_PATTERNS.GET_PARAMS_AND, CheckinAppConstants.CHECKIN_PATTERNS.QUERY_GLOBAL_MOD);
                    while ((tempParam = regex.exec(location.search)[0]) !== '') {
                        if (docRootParam === '' && tempParam.charAt(0) !== CheckinAppConstants.CHECKIN_PATTERNS.QUERY_START) {
                            tempParam = CheckinAppConstants.CHECKIN_PATTERNS.QUERY_START + tempParam.substr(1);
                        }
                        tempRegex = new RegExp(CheckinAppConstants.CHECKIN_PATTERNS.GET_PARAMS_EQUAL);
                        if (tempRegex.exec(tempParam)[0].substr(1) !== CheckinAppConstants.USER_PARAMS.SURNAME && tempRegex.exec(tempParam)[0].substr(1) !== CheckinAppConstants.USER_PARAMS.PNR && tempRegex.exec(tempParam)[0].substr(1) !== CheckinAppConstants.UNDOCHECKIN.UNDOCKI && tempRegex.exec(tempParam)[0].substr(1) !== CheckinAppConstants.UNDOCHECKIN.TRAVEL_AGENT) {
                            docRootParam = docRootParam + tempParam;
                        }
                    }

                    return docRootParam;
                }
            }

            function goLoggedAccess () {
                let bannerRenderedEvent;
                CkiCommonsGetLoginInfoService.checkCustomerStatus(true).then(
                    (data) => {
                        if (data) {
                            localStorageService.set('loggedInfo', localStorageService.get('customerData'));
                            CkiDatalayerUtilsService.updateDatalayerInitType(CkiDatalayerConstants.DATALAYER_VALUES.INIT_IB_PLUS);
                            if (params.code !== null) {
                                ModalService.isWaiting();
                                localStorageService.set('confirmationPNR', false);
                                searchFlightsDeepLink();
                            } else if (gdrError) {
                                sessionStorage.removeItem('IBERIACOM_GDR_PA_ERROR', { path: '/' });
                                $location.path(gdrError.nextStep);
                            } else {
                                if (params.pnr && params.surname && !gdrInfo) {
                                    CkiDatalayerUtilsService.updateDatalayerInitType(CkiDatalayerConstants.DATALAYER_VALUES.INIT_LOCATOR);
                                    localStorageService.set('confirmationPNR', false);
                                    searchFlightsPassengers();
                                } else if (gdrInfo) {
                                    sessionStorage.removeItem('IBERIACOM_GDR_PA_ACCESS', { path: '/' });
                                    localStorageService.set('checkinPa', true);
                                    localStorageService.set('flowId', gdrInfo.checkinId);
                                    doCheckinFromGdr();
                                } else {
                                    bannerRenderedEvent = $rootScope.$emit('destroyBanners', true);
                                    $rootScope.$broadcast('updateLoginModelEvent');
                                    if (!CommonsUserUtilsService.isSoftUser()) {
                                        $location.path('/ibcose2');
                                    } else {
                                        ModalService.isNotWaiting();
                                    }
                                }
                            }
                        } else {
                            ModalService.isNotWaiting();
                            goAnonymous();
                        }
                    },
                    (error) => {
                        ModalService.isNotWaiting();
                        serviceError(error);
                        goAnonymous();
                    });

            }

            function goAnonymous () {
                CommonsLoginUtilsService.updateStateToAnonymous();
                CkiDatalayerUtilsService.updateDatalayerInitType(CkiDatalayerConstants.DATALAYER_VALUES.INIT_LOCATOR);
                if (params.code !== null) {
                    ModalService.isWaiting();
                    localStorageService.set('confirmationPNR', false);
                    getEndpointsVersion(searchFlightsDeepLink);
                } else if (gdrError) {
                    sessionStorage.removeItem('IBERIACOM_GDR_PA_ERROR');
                    $location.path(gdrError.nextStep);
                } else {
                    const autoCKIAndNotGdrInfo = params.pnr && params.surname && !gdrInfo;
                    if (autoCKIAndNotGdrInfo) {
                        ModalService.isWaiting();
                        localStorageService.set('confirmationPNR', false);
                        getEndpointsVersion(searchFlightsPassengers);
                    } else if (gdrInfo) {
                        sessionStorage.removeItem('IBERIACOM_GDR_PA_ACCESS');
                        localStorageService.set('checkinPa', true);
                        localStorageService.set('flowId', gdrInfo.checkinId);
                        getEndpointsVersion(doCheckinFromGdr);
                    } else {
                        getEndpointsVersion(GetFrequentFlyersService.getFrequentFlyers);
                    }
                }
            }

            function doCheckinFromGdr() {
                const selectedSegment = gdrInfo.selectedSegment[0];
                const printBoardingCard = gdrInfo.nextStep === CheckinAppConstants.SHUTTLE_NEXT_STEPS.BOARDING_CARDS;
                const arrSegments = [],
                    segments = [],
                    passengerAvailable = [];
                angular.extend(selectedSegment, { whatToDo: { selectedBlock: { nextStep: gdrInfo.nextStep } } });
                segments.push(selectedSegment);
                for (let i = 0; i < gdrInfo.selectedPassenger.length; i++) {
                    passengerAvailable.push({ id: gdrInfo.selectedPassenger[i] });
                }
                segments[0].pasajerosSelected = passengerAvailable;

                GetCKICachedInformationService.getCachedInformation().then(getCachedInformationSuccess, getCachedInformationError);

                function getCachedInformationSuccess(cachedData) {
                    const checkinPa = localStorageService.get("checkinPa") || false;
                    localStorageService.set("bookingInfo", cachedData);

                    if (cachedData?.gdsLocator) localStorageService.set("PNR", cachedData.gdsLocator);
                    if (checkinPa) {
                        FlightsPassengersService.searchFlightsAndPassengers().then(searchFlightsAndPassengersSuccess);
                    } else {
                        UpdateFlightsPassengerInfoService.updateFlightsPassengerInfo(passengerAvailable, segments, printBoardingCard, [], selectedSegment);
                    }

                    function searchFlightsAndPassengersSuccess(data) {
                        for (let i = 0; i < data?.flightsPassengersInfo?.segments?.length; i++) {
                            const segmentData = data.flightsPassengersInfo.segments[i];
                            for (let j = 0; j < segments.length; j++) {
                                const segment = segments[j];
                                if (segmentData.id.toString() === segment.id.toString()) {
                                    arrSegments.push(segmentData);
                                }
                            }
                        }
                        if (arrSegments.length > 0) {
                            initHeader(data);
                            localStorageService.set("segmentsSelected", arrSegments);
                            angular.extend(selectedSegment, arrSegments[0]);
                            selectedSegment.whatToDo.selectedBlock = { nextStep: gdrInfo.nextStep };
                        }
                        UpdateFlightsPassengerInfoService.updateFlightsPassengerInfo(passengerAvailable, arrSegments, printBoardingCard, [], selectedSegment);
                    }
                }

                function getCachedInformationError(error) {
                    ModalService.isNotWaiting();
                    ModalService.setErrorMessage(error.message);
                    ModalService.isError(error);
                }
            }

            function getEndpointsVersion (callback) {
                EndpointsService.getEndpoints().then(
                    (endpointsData) => {
                        UtilsService.saveEndpoints(endpointsData.data.endpoints);
                        callback();
                    }, () => {
                        callback();
                    });
            }
        }

        function getDinamicPricingCookieParameter () {
            const isDinamicPricing = !!$cookies.get(CheckinAppConstants.COOKIES.DYNAMIC_PRICING);
            return isDinamicPricing;
        }

        function initHeader (data) {
            const headerInfo = UtilsService.getInfoHeader(data?.flightsPassengersInfo?.segments, data?.flightsPassengersInfo?.passengers);

            $rootScope.showMainHeader = false;
            $rootScope.showHeaders = true;
            localStorageService.set("headerInfo", headerInfo);
            $timeout(() => {
                NewMainHeaderFacade.initHeader(
                    {
                        originDestination: headerInfo,
                        redemption: '',
                        flightType: CheckinAppConstants.FLIGHTTYPE,
                        currency: '',
                        showModalBackHome: true
                    },
                    { hasSteps: false, steps: 'DEFAULT_STEPS', position: 0 },
                    {
                        onLogin: onLogin,
                        onError: onError,
                        afterLogin: () => {},
                        userLogged: localStorageService.get('userLogged'),
                        loggedData: localStorageService.get('customerData') || localStorageService.get('membershipData') || undefined
                    }
                );
            });
        }

        function onLogin () {
            CommonsModalService.showWaitingModal('ib-modal-loading-plane', 'ib-modals ib-modals--transparent ib-modals--loading-page', true);
        }

        function onError (error) {
            CommonsModalService.finishWaiting();
            CommonsModalService.showGenericDynamicModal( true, 'generic-login-modal-error.html', error, 'GenericErrorModalController', error?.stateUserLogged ? 'ib-modals--backdrop-off' : null);
        }
    }
})();
